
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-dam-preview-image',
  templateUrl: './dam-preview-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamPreviewImageComponent  {
  @Input() id: number;
  constructor(protected ref: NbDialogRef<DamPreviewImageComponent>) {

  }

  dismiss(confirmed: boolean) {
    this.ref.close(confirmed);
  }


}
